import React from 'react'
import Header from '../../components/Header'
import { Toast, Modal } from 'antd-mobile';
import './unlock.less?v=2019'
import { getUrl } from '../../utils/deciphering'
import wx from 'weixin-js-sdk'

import getFreeImg from '../../images/diary/diary_unlock_getFreeBtn.png'

import playImg from '../../images/diary/diary_unlock_play.png'
import pauseImg from '../../images/diary/diary_unlock_pause.png'
import smallPlayImg from '../../images/diary/diary_unlock_btn_smallPlay.png'
import smallPauseImg from '../../images/diary/diary_unlock_btn_smallPause.png'
import unlockLogoImg from '../../images/diary/diary_unlock_huhuLogo.png'
import cateBgImg from '../../images/diary/diary_unlock_cate_bg.png'

import { storyDetail, shareUnlockCate } from '../../api/album'
import { isWeChat, getQueryString, jumpApp, getNickName, timeFormat, formatMTime, getAllTime, baiduStatistics, baiduStatisticsBehaviour, jumpYYB } from '../../utils/utils'
import ShareShadeLayer from '../../components/Sound/shareShadeLayer'
import Share from '../../components/Sound/share'
import { advert } from '../../api/count'
import { getShareContent } from '../../api/share'
import Cookies from 'js-cookie'
import DocumentTitle from 'react-document-title'
import { global } from '../../config/index'
import { getWithdrawRole } from '../../api/hcFission'

export default class DiaryUnlockPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: isWeChat(),
      data: {},
      sign: '',
      wxShareVisible: false,
      wxShareItem: {},
      shareContent: {},
      paused: true,
      isFinished: false,
    }
  }

  componentWillMount = () => {
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (!sign && this.state.client == 1) {
      let url = global.wxAuthorizeBaseUrl + '?op=wxWebSpecLogin&from_sso_id=' + getQueryString('from_sso_id') + '&invite_type='
        + getQueryString('invite_type') + '&picture_id=' + getQueryString('picture_id') + '&channel_id=' + getQueryString('channel_id')
        + '&specid=' + getQueryString('specid') + '&base_url=' + global.href + 'diary/unlock'
      window.location.href = url;
    } else {
      this.setState({
        sign: true
      })
    }
  }

  componentDidMount() {
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (sign) {
      this.requestList()
      this.initPlay()
      baiduStatistics();

      setTimeout(function () {
        baiduStatisticsBehaviour('专辑解锁分享落地页', '曝光', 'h5_mfjs_fxy')
      }, 500)

      advert({
        operate: 'shareUnlock',
        label: 'open_shareUnlock_page',
      }).then((res) => { })
    }
  }
  //用户行为
  handleUserAction = (pageName, action, actionDetail) => {
    baiduStatisticsBehaviour(pageName, action, actionDetail);
  }

  requestList = () => {
    let specid = getQueryString('specid') ? getQueryString('specid') : 0
    let from_sso_id = getQueryString('from_sso_id') ? getQueryString('from_sso_id') : 0
    shareUnlockCate({ specid: specid, from_sso_id: from_sso_id }).then((res) => {
      //console.log(res)
      this.setState({
        data: res
      }, () => {
        if (this.state.client == 1) {
          this.handleGetShareContent(specid)
        }
      })
    })
  }

  handleGetShareContent = (specid) => {
    getShareContent({ type: 9, specid: specid }).then((res) => {
      this.setState({
        shareContent: res
      }, () => {
        this.handleWxShaer({})
      })
    })
  }

  handleWxShaer = (item) => {
    let res = this.state.shareContent
    let wxShareVisible = true
    let url = res.url
    if (res.url.indexOf('?') > 0) {
      url += '&'
    } else {
      url += '?'
    }
    url += 'invite_type=' + res.invite_type + '&picture_id=' + res.picture_id + '&channel_id=' + res.channel_id
    if (item.id) {
      url += '&from_sso_id=' + item.from_sso_id
      advert({
        operate: 'shareUnlock',
        label: 'share_friend_9',
      }).then((res) => { })
    } else {
      wxShareVisible = false
      url += '&from_sso_id=' + Cookies.get('sso_id')
    }
    this.setState({
      wxShareVisible: wxShareVisible,
      wxShareItem: {
        title: res.name,
        link: url,
        desc: res.detail,
        imgUrl: res.image,
      }
    })
  }


  onClose = key => () => {
    this.setState({
      [key]: false,
    });
  }

  initPlay = () => {
    let audio = this.refs.audio
    let _this = this

    //开始播放：
    audio.onplay = () => {
      this.handleUserAction('专辑解锁分享落地页', '点击', 'h5_mfjs_bf');
      _this.setState({
        paused: false
      })
    }

    //暂停播放：
    audio.onpause = function () {
      _this.setState({
        paused: true
      })
    }

  }

  audioPlay = () => {
    let audio = this.refs.audio
    if (audio.paused) {
      audio.play();
    } else {
      audio.pause();
    }
  }
  //跳转应用宝
  handleDownload = (action, actionDetail) => {
    baiduStatisticsBehaviour('专辑解锁分享落地页', action, actionDetail)
    jumpYYB(actionDetail, this.props.location.pathname);
  }

  getFree = () => {
    Toast.show("免费领取了");
  }

  render() {
    let { data, client, sign, wxShareVisible, wxShareItem, paused } = this.state
    return (
      <DocumentTitle title={data && data.cate_info ? data.cate_info.name : '呼呼收音机'}>
        {
          client != 1 || sign ?
            <div id="unlock-body-2">

              <div className="unlock-content">
                <div className="titleView">
                  <img src={data && data.cate_info ? data.cate_info.icon : ''} alt="" />
                  <p className="label">我和宝宝正在听<br />《{data && data.cate_info ? data.cate_info.name : '呼呼收音机'}》</p>
                </div>

                <div id="song-container">
                  {
                    data && data.cate_info ?
                      <div className="unlock-container">
                        <div className="album-img">
                          <img src={data && data.cate_info ? data.cate_info.image : ''} alt="" />
                          <div className="diary-control">
                            <div className="play-btn">
                              <img onClick={this.audioPlay}
                                src={paused ? playImg : pauseImg}
                                alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                </div>

                <div className="unlockBottomView">
                  <div className="albumName">
                    {data && data.cate_info ? data.cate_info.name : ''}
                  </div>

                  <div className="getFreeBtn">
                    <div className="getFreeBtn-btn" onClick={this.handleDownload.bind(this, '点击', 'h5_mfjs_mflq')}>

                    </div>
                  </div>

                  <div className="unlockItems">
                    <div className="firstItem" onClick={this.handleDownload.bind(this, '点击', 'h5_mfjs_zj1')}>
                      <img src={data && data.cate_info ? data.cate_info.image1 : ''} alt="" />
                      <div className="diary-control">
                        <div className="play-btn">
                          <img onClick={this.audioPlay}
                            src={smallPlayImg}
                            alt="" />
                        </div>
                      </div>
                      <div className="cate">
                        <img src={cateBgImg} alt="" />
                        <p>{data && data.cate_info ? data.cate_info.label1 : ''}</p>
                      </div>
                    </div>
                    <div className="secondItem" onClick={this.handleDownload.bind(this, '点击', 'h5_mfjs_zj2')}>
                      <img src={data && data.cate_info ? data.cate_info.image2 : ''} alt="" />
                      <div className="diary-control">
                        <div className="play-btn">
                          <img onClick={this.audioPlay}
                            src={smallPlayImg}
                            alt="" />
                        </div>
                      </div>
                      <div className="cate">
                        <img src={cateBgImg} alt="" />
                        <p>{data && data.cate_info ? data.cate_info.label2 : ''}</p>
                      </div>
                    </div>
                    <div className="thirdItem" onClick={this.handleDownload.bind(this, '点击', 'h5_mfjs_zj3')}>
                      <img src={data && data.cate_info ? data.cate_info.image3 : ''} alt="" />
                      <div className="diary-control">
                        <div className="play-btn">
                          <img onClick={this.audioPlay}
                            src={smallPlayImg}
                            alt="" />
                        </div>
                      </div>
                      <div className="cate">
                        <img src={cateBgImg} alt="" />
                        <p>{data && data.cate_info ? data.cate_info.label3 : ''}</p>
                      </div>
                    </div>
                    <div className="fourthItem" onClick={this.handleDownload.bind(this, '点击', 'h5_mfjs_zj4')}>
                      <img src={data && data.cate_info ? data.cate_info.image4 : ''} alt="" />
                      <div className="diary-control">
                        <div className="play-btn">
                          <img onClick={this.audioPlay}
                            src={smallPlayImg}
                            alt="" />
                        </div>
                      </div>
                      <div className="cate">
                        <img src={cateBgImg} alt="" />
                        <p>{data && data.cate_info ? data.cate_info.label4 : ''}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <audio ref="audio" src={data && data.cate_info ? data.cate_info.filename : ''}
                  style={{ display: 'none' }}>
                  Your browser does not support the audio element.
                      </audio>
              </div>
              <div className="bottomLogo">
                <img src={unlockLogoImg} alt="" />
              </div>
              {
                client == 1 ? <ShareShadeLayer wxShareVisible={wxShareVisible} onShow={this.onClose('wxShareVisible')} />
                  : ''
              }

              {
                client == 1 && wxShareItem.title ?
                  <Share obj={wxShareItem} onClose={this.onClose('wxShareVisible')} /> : ''
              }
            </div>
            : ''
        }
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/diary/unlock.js